/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";
import styled from "styled-components";

import {WealthyEnv} from "helpers";
import {colors} from "nxtconstants";

const arrowRight = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-advisors-carousel-right-arrow.svg`;

const propTypes = {
  breadCrumbs: PropTypes.array
};

const defaultProps = {
  breadCrumbs: []
};

const BreadCrumbs = ({
  breadCrumbs
}) => {
  const loadBreadCrumbs = (breadCrumbs) => {
    return breadCrumbs.map((path, index) => (
      <BreadCrumbItem key={index}>
        <SafeLink href={`${path.url}`}>
          {path.name}
        </SafeLink>
      </BreadCrumbItem>
    ));
  };

  return (
    <BreadCrumbsWrapper>
      <BreadCrumbsList>
        {
          loadBreadCrumbs(breadCrumbs)
        }
      </BreadCrumbsList>
    </BreadCrumbsWrapper>
  );
};

const BreadCrumbsWrapper = styled.div`
`;

const BreadCrumbsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

const BreadCrumbItem = styled.li`
  text-transform: capitalize;
  position: relative;
  &:not(:last-child) {
    padding-right: 3rem;
  }
  &::after {
    content: "";
    position: absolute;
    right: 1.3rem;
    top: 0;
    bottom: 0;
    margin: auto;
    background-image: url(${arrowRight});
    height: 11px;
    width: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  &:last-child::after {
    display: none;
  }
  a:hover {
    text-decoration: underline;
  }
  &:last-child {
    a {
      color: ${colors.textGray};
    }
  }

  @media (max-width: 576px) {
    a {
    font-size: 1.2rem;
    }
  }
`;

BreadCrumbs.propTypes = propTypes;
BreadCrumbs.defaultProps = defaultProps;

export default BreadCrumbs;
